import type { FaireProductEntity } from "../../entity_types/product";

export const p_nzeudz7sx6: FaireProductEntity = {
  token: "p_nzeudz7sx6",
  type: "product",
  name: "XHN03-ASIS V NECK FRINGE HEM PULLOVER SWEATER",
  brandToken: "b_dkldnd6ff4",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5785b19d4f26c4acad697b28834c154e9e04ef77d7a04cbeee83afa78f949cdf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4aa7e60072da421e685e49a8757af57f7151ceb955dbb3ad2d188c4c6dd78b7d.jpeg",
    "https://cdn.faire.com/fastly/76e43d0289e7ecedb71c59c24617eb1f5fdc950610fe9c1199a96eb64af406c3.jpeg",
    "https://cdn.faire.com/fastly/1657bdce2694cf20791dc1cbfd979fd1f7323fb6341f208b8458beb558df232c.jpeg",
    "https://cdn.faire.com/fastly/8b7bc4a727c6fc004afc1f1ec9b988f7a8419604a99365b54a161c4623528585.jpeg",
    "https://cdn.faire.com/fastly/9105334cb318db67c46de5bec517ffc6a5fbc8d3003c90aed7eb9388dc52ab26.jpeg",
    "https://cdn.faire.com/fastly/96e71d243b5ab16230230d7833dbcba335b95cda46e35fa0a9116c214d81e7a1.jpeg",
    "https://cdn.faire.com/fastly/41e9552cbe1e64ee3347aed22dc5cfea7adc03807b17658a60ac02ce9b80d31b.jpeg",
    "https://cdn.faire.com/fastly/974559233d32e5edf467ed085c7a1e9c36ccf68d8ee409750f2901d56917b4b2.jpeg",
    "https://cdn.faire.com/fastly/d27b4b393e981f9edaa3c4f66325b839bbacea9ee4d853a6bc6c85d6d9efe7d7.jpeg",
    "https://cdn.faire.com/fastly/8cd2ebbe25a752c51323bf6d1728c0c2ae7fea4dc92e4a1dfeeabc0204bb01aa.jpeg",
    "https://cdn.faire.com/fastly/9c36a6efdcf6f16a822008b2e579e6110ea704bf369616bc8cde5cabd8341d8d.jpeg",
    "https://cdn.faire.com/fastly/120c3c80967010da69d8a7d75aa25f4c9aa7ab888e6692a466fe303213576c4d.jpeg",
    "https://cdn.faire.com/fastly/1fddd9776a5bfed19249710b409c25e5f8555b2b53c752eb87c4e23c9af71d73.jpeg",
    "https://cdn.faire.com/fastly/577fb73e8e721210e020ec67125b60b5cab83bae8e7c9178d5930b059cba34cf.jpeg",
    "https://cdn.faire.com/fastly/e2fc6c6a18c8c3887c230692aace6093256acf18d0fa50d9f5592a482c6615da.jpeg",
    "https://cdn.faire.com/fastly/1a94630adb0ecc8c89fc46c705fc5fe2c21990f9a27001c662cc81f22e481539.jpeg",
    "https://cdn.faire.com/fastly/af85a9b71e57801fc2f2f8458d2b38a21b98e4d6bce531eba62121b17c9752f0.jpeg",
    "https://cdn.faire.com/fastly/cbe8abb5ada31ec1f47fce6d4c1f01125e9f8dd98b045d7bdc349ddd0a955350.jpeg",
    "https://cdn.faire.com/fastly/10c457cf40a19f7cf11451e2453d877e9fe30068fe0943c12e470caddf234404.jpeg",
    "https://cdn.faire.com/fastly/ff14eb5b5451dec56c1ca362c13248c7926f04c7c06689fa47f2ef6a2b5c6bf4.jpeg",
  ],
  priceDollars: 220.33,
  description:
    "Embrace a global, bohemian lifestyle with ANGIE's V Neck Fringe Hem Pullover Sweater. This knitwear piece is designed for everyday wear, with a unique fringe hem that adds a touch of vintage charm. Our designers are inspired by art from around the world, resulting in bold, colorful, and embellished pieces. This sweater embodies the well-traveled, romantic spirit of the ANGIE brand, making it a perfect addition to any woman's wardrobe.",
  tags: [],
  msrpDollars: 440.65,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:11.899Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
